import UploadSchema from './UploadSchema';

export default UploadSchema;
